import { render } from "./PurchaseDefectiveItemList.vue?vue&type=template&id=3efcf761"
import script from "./PurchaseDefectiveItemList.vue?vue&type=script&lang=js"
export * from "./PurchaseDefectiveItemList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__